import { ShiftCode, ShiftSlot } from '../../../../shared/types/shiftTypes.ts';

export function formatShiftName(shiftSlot: ShiftSlot, shiftCode: ShiftCode): string {
    const slotLabel = shiftSlot[0].toUpperCase() + shiftSlot.slice(1);
    return shiftCode === 'N' ? slotLabel : `${slotLabel} ${shiftCode}`;
}

export function formatShiftEnd(value: Date): string {
    const date = new Date(value);
    return date.toLocaleDateString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }) + ` ${formatTime(date)}`;
}

export function formatDateTime(value: Date): string {
    const date = new Date(value);
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }) + ` ${formatTime(date)}`;
}

export function formatMinutes(minutes: number): string {
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes === 0 ? `${hours} h` : `${hours} h ${remainingMinutes} min`;
}

function formatTime(date: Date): string {
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}
